import { api } from "@/lib/api";
import {
  CreateHotelRoom,
  createHotelRoomToDto,
  HotelRoom,
  HotelRoomDtoSchema,
  hotelRoomFromDto,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import {
  getAllHotelRoomsQueryOptions,
  getHotelRoomsQueryOptions,
} from "./get.hooks";

export function useCreateHotelRoom(
  hotelId: string,
  opts?: {
    onSuccess?: (hotelRoom: HotelRoom) => void;
    onError?: () => void;
  },
) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (hotelRoom: CreateHotelRoom) => {
      const dto = createHotelRoomToDto(hotelRoom);
      const result = await api.post(
        "/api/hotel-rooms",
        dto,
        HotelRoomDtoSchema,
      );
      return hotelRoomFromDto(result);
    },
    onSuccess: (hotelRoom) => {
      queryClient.setQueryData(
        getHotelRoomsQueryOptions(hotelId).queryKey,
        (old) => [...(old ?? []), hotelRoom],
      );
      queryClient.setQueryData(getAllHotelRoomsQueryOptions.queryKey, (old) => [
        ...(old ?? []),
        hotelRoom,
      ]);
      toast({
        title: "toast.hotelCreated",
        variant: "success",
      });
      opts?.onSuccess?.(hotelRoom);
    },
    onError: () => {
      toast({
        title: "toast.createHotelError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
